import { render, staticRenderFns } from "./BillHistory.vue?vue&type=template&id=4678a2a4&scoped=true&"
import script from "./BillHistory.vue?vue&type=script&lang=js&"
export * from "./BillHistory.vue?vue&type=script&lang=js&"
import style0 from "./BillHistory.vue?vue&type=style&index=0&id=4678a2a4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4678a2a4",
  null
  
)

export default component.exports